// extracted by mini-css-extract-plugin
export default {"card":"MovieCard_card__760t6","movieCardImg":"MovieCard_movieCardImg__UWcPv"};